/**
 * Phase 6 pre-INTEGRATE cleanup (Item 1) — the live Canvas3D singleton registry.
 *
 * The board's live Canvas3D instance USED to be exposed as `window.__c3d` (a
 * verify-harness debug handle that turned out to be LOAD-BEARING: the accessory
 * selector's mini-3D AHU-preview tab reads it to clone the live canvas caches —
 * useAccessoryPreviewCanvas.ts). That window global is removed; this module is
 * the proper replacement: a tiny module-level registry holding the one live
 * Canvas3D for the board (there is exactly one board canvas at a time, like the
 * legacy single canvasView).
 *
 * - canvas3d.ts calls setLiveCanvas3D(this) where it used to set window.__c3d,
 *   and clears it on dispose() so a route change does not leave a stale handle.
 * - useAccessoryPreviewCanvas imports getLiveCanvas3D() instead of reading the
 *   window.
 *
 * Typed loosely (`unknown`) to avoid an import cycle with canvas3d.ts (which
 * imports nothing from here at type level); the single consumer casts.
 */

let liveCanvas3D: unknown = null;

/** canvas3d.ts ctor: register the live board canvas instance. */
export function setLiveCanvas3D(instance: unknown): void {
  liveCanvas3D = instance;
}

/** canvas3d.ts dispose(): clear the handle when THIS instance is the live one. */
export function clearLiveCanvas3D(instance: unknown): void {
  if (liveCanvas3D === instance) liveCanvas3D = null;
}

/** useAccessoryPreviewCanvas: the live canvas to clone the preview from. */
export function getLiveCanvas3D(): unknown {
  return liveCanvas3D;
}
